<!--
  Standby screensaver. Full-bleed cross-fading photos with a bottom caption
  card, mirroring the Clover kiosk idle screen. Shown only while active.
-->
<div class="standby" *ngIf="active" (click)="dismiss()" (touchstart)="dismiss()" role="button" tabindex="0">
  <div class="standby__stage">
    <div class="standby__slide"
         *ngFor="let slide of slides; let i = index; trackBy: trackByIndex"
         [class.is-current]="i === index"
         [style.background-image]="'url(\'' + slide.image + '\')'">
    </div>
  </div>

  <div class="standby__panel" *ngIf="current">
    <div class="standby__title" *ngIf="current.title">{{ current.title }}</div>
    <div class="standby__subtitle" *ngIf="current.subtitle">{{ current.subtitle }}</div>
    <div class="standby__cta">Tap screen to begin</div>
  </div>
</div>
